import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useWorkflowTemplateWithCardDefinition(id?: string | null): {
  workflowTemplate?: MBAPI.WorkflowTemplateWithCardDefinition;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    MBAPI.GetWorkflowTemplateWithCardDefinitionQuery,
    MBAPI.GetWorkflowTemplateWithCardDefinitionQueryVariables
  >(Queries.workflow.getWorkflowTemplateWithCardDefinition, {
    variables: { id: id ?? '' },
    skip: isNil(id),
  });
  const workflowTemplate = data?.getWorkflowTemplate ?? undefined;
  return { workflowTemplate, loading, error };
}
